"use client";
import { useCallback } from "react";
import { useMutation } from "@stadium/services/apollo-client";
import { MANAGE_DRAFT_AUTOMATED_CATALOG } from "@stadium/shared/src/graphql/mutations/catalog/manage-draft-automated-catalog";

import { showError } from "@stadium/services/react-toastify";

const useManageDraftCollection = () => {
  const [manageDraftCatalog, { loading: isSavingDraftSwag }] = useMutation(
    MANAGE_DRAFT_AUTOMATED_CATALOG,
  );
  const saveDraftSwag = useCallback(
    async (input) => {
      try {
        const { data } = await manageDraftCatalog({ variables: { input } });
        const response = data?.manageDraftAutomatedCatalog;
        if (response?.errors?.length) {
          response.errors.forEach((error) => showError(error));
          return;
        }
        if (!response.catalog) {
          showError("Unable to save draft swag collection.");
          return;
        }
        return response?.catalog;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        showError("Unable to save draft swag collection.");
        return;
      }
    },
    [manageDraftCatalog],
  );

  return { saveDraftSwag, isSavingDraftSwag };
};

export default useManageDraftCollection;
